export const locateMe = async (
  callbackFn: (position: GeolocationPosition) => void
): Promise<void> => {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(callbackFn, () => {
      window.notifyUser("error", {
        message: "Unable to detect your location.",
        description:
          "To access location features, please enable location services in your device settings.",
      })!;
    });
  } else {
    window.notifyUser("error", {
      message: "Unable to detect your location.",
      description:
        "To access location features, please enable location services in your device settings.",
    })!;
  }
};
